<template>
  <Page>
    <div class="two-columns">
      <div style="flex: 3">
        <div class="title">{{ $t('report.exportIntroduction') }}</div>

        <div class="content">
          <div class="section">
            <div class="section-title">{{ $t('report.exportIntroductionExplanation.travelTime.title') }}</div>

            <div v-if="study.public_transport_provider === 1" class="item">
              <div class="item-title">
                {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
              </div>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.1') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.2') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.3') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.googleMaps.4') }}</span>
            </div>

            <div v-if="!study.public_transport_provider || study.public_transport_provider === 2" class="item">
              <div class="item-title">
                {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
              </div>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.1') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.2') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.3') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.navitia.4') }}</span>
            </div>

            <div v-if="study.public_transport_provider === 3" class="item">
              <div class="item-title">
                {{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.title') }}
              </div>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.1') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.2') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.3') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.publicTransport.travelTime.4') }}</span>
            </div>

            <div v-if="!study.private_transport_provider || study.private_transport_provider === 1" class="item">
              <div class="item-title">
                {{
                  study.withWalkingTimes
                    ? $t('report.exportIntroductionExplanation.travelTime.privateTransport.title')
                    : $t('report.exportIntroductionExplanation.travelTime.privateTransport.titleNoWalk')
                }}
              </div>
              <span>{{
                study.withWalkingTimes
                  ? $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.1')
                  : $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.1NoWalk')
              }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.googleMaps.2') }}</span>
            </div>

            <div v-if="study.private_transport_provider === 3" class="item">
              <div class="item-title">
                {{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.title') }}
              </div>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.1') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.2') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.travelTime.privateTransport.travelTime.3') }}</span>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.impactOnCollaborators.title') }}</div>
            <div class="item">
              <span>{{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text1') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text2') }}</span>
              <span>{{ $t('report.exportIntroductionExplanation.impactOnCollaborators.text3') }}</span>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.outlier.title') }}</div>
            <div class="item">
              <span>{{ $t('report.exportIntroductionExplanation.outlier.text1', { duration: study.sensitive_case_duration || 45 }) }}</span>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.environmentalImpact.title') }}</div>
            <div class="item">
              <template v-if="!(study.public_transport_provider === 3 || study.private_transport_provider === 3)">
                <span v-if="studyIsInFrance">{{ $t('report.exportIntroductionExplanation.environmentalImpact.text2France') }}</span>
                <span v-else>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text2') }}</span>
                <span>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text3') }}</span>
              </template>

              <template v-if="study.public_transport_provider === 3 || study.private_transport_provider === 3">
                <span>{{ $t('report.exportIntroductionExplanation.environmentalImpact.text1') }}</span>
              </template>
            </div>

            <div v-if="study.public_transport_provider === 3 || study.private_transport_provider === 3" class="trasport-co2">
              <div class="transport-column">
                {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.1') }}<br />
                {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.2') }}<br />
                {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.3') }}<br />
              </div>

              <div class="transport-column">
                {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.4') }}<br />
                {{ $t('report.exportIntroductionExplanation.environmentalImpact.transports.5') }}<br />
              </div>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.whatIs.travelTimeLimitsTitle') }}</div>
            <div class="item">
              <span>{{ $t('report.exportIntroductionExplanation.whatIs.travelTimeLimitsText') }}</span>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.whatIs.optimizedRouteTitle') }}</div>
            <div class="item">
              <span>{{ $t('report.exportIntroductionExplanation.whatIs.optimizedRouteText') }}</span>
            </div>

            <div class="section-title">{{ $t('report.exportIntroductionExplanation.whatIs.personalizedTripTitle') }}</div>
            <div class="item">
              <span>{{ $t('report.exportIntroductionExplanation.whatIs.personalizedTripText') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div style="flex: 4">
        <div class="title">{{ $t('report.currentSitesTargetSites') }}</div>

        <div class="content">
          <div class="map" :style="{ backgroundImage: `url(${sitesMapUrl})` }" />

          <div class="site-container-site">
            <div v-for="site in currentSites" :key="site.id" class="site">
              <div class="marker current-marker"></div>
              <div class="site-info">
                <div class="site-name">{{ site.name }}</div>
                <div class="site-address">{{ site.address }}</div>
              </div>
            </div>

            <div v-for="(site, index) in targetSites" :key="site.id" class="site" :style="index === 0 && { gridRowStart: 1 }">
              <div class="marker target-marker" :class="`marker-${site.index + 1}`"></div>
              <div class="site-info">
                <div class="site-name">{{ site.name }}</div>
                <div class="site-address">{{ site.address }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="title" style="margin-top: 24px">{{ $t('report.collaboratorSource') }}</div>

        <div class="content">
          <div class="map" :style="{ backgroundImage: `url(${collaboratorsMapUrl})` }" />

          <div class="site-container-collaborator">
            <div class="site">
              <div class="marker small"></div>
              <div class="site-info">
                <div class="site-name">{{ $t('pointCollaborators.10') }}</div>
              </div>
            </div>
            <div class="site">
              <div class="marker">10+</div>
              <div class="site-info">
                <div class="site-name">{{ $t('pointCollaborators.30') }}</div>
              </div>
            </div>
            <div class="site">
              <div class="marker">30+</div>
              <div class="site-info">
                <div class="site-name">{{ $t('pointCollaborators.60') }}</div>
              </div>
            </div>
            <div class="site">
              <div class="marker">60+</div>
              <div class="site-info">
                <div class="site-name">{{ $t('pointCollaborators.99') }}</div>
              </div>
            </div>
            <div class="site">
              <div class="marker">99+</div>
              <div class="site-info">
                <div class="site-name">{{ $t('pointCollaborators.100') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Report/BasePage';
import { mapActions } from 'vuex';

export default {
  components: { Page },

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  data() {
    return {
      sitesMapUrl: null,
      collaboratorsMapUrl: null,
    };
  },

  computed: {
    studyIsInFrance() {
      return this.study.countries?.includes('France');
    },

    filteredSiteIds() {
      return this.export.sites.map(site => site.id);
    },

    currentSites() {
      if (!this.export || !this.study) return [];

      return this.study.sites.filter(site => this.filteredSiteIds.includes(site.id)).filter(site => site.type_id === 1);
    },

    targetSites() {
      if (!this.export || !this.study) return [];

      return this.study.sites
        .filter(site => this.filteredSiteIds.includes(site.id))
        .filter(site => site.type_id === 2)
        .map((s, i) => {
          s.index = i;
          return s;
        });
    },
  },

  created() {
    this.getExportSiteMap({ id: this.export.public_id }).then(({ url }) => (this.sitesMapUrl = url));

    this.getExportSiteMapCollaborator({ id: this.export.public_id }).then(({ url }) => (this.collaboratorsMapUrl = url));
  },

  methods: {
    ...mapActions(['getExportSiteMap', 'getExportSiteMapCollaborator']),
  },
};
</script>

<style scoped lang="scss">
@use 'sass:color';
@use '@/styles/colors.scss';

.page {
  padding: 32px;
  box-sizing: border-box;

  .two-columns {
    display: flex;
    flex-direction: row;
    gap: 32px;
  }

  .title {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .content {
    display: flex;

    .section {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .section-title {
        font-weight: bold;
        color: #3c3c3b;
      }

      .item {
        font-size: 10px;

        .item-title {
          position: relative;
          font-weight: bold;

          &::after {
            content: '';
            margin: 8px 0;
            width: 64px;
            height: 4px;
            border-radius: 4px;
            background: colors.$main-color;
          }
        }

        span {
          display: block;
        }

        .item-transport {
          margin-top: 4px;
          margin-left: 16px;

          &:nth-child(2n) {
            margin-bottom: 8px;
          }

          span {
            font-weight: 600;
          }
        }
      }
    }

    .map {
      flex-shrink: 0;
      width: 240px;
      height: 240px;
      border-radius: 4px;
      pointer-events: none;
      box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.2);
      background-color: colors.$grey-color;
      background-position: center;
      background-size: cover;
    }

    .site-container-site {
      margin-left: 12px;
      height: 100%;
      width: 100%;

      display: grid;
      grid-auto-flow: column;
      grid-template-rows: repeat(10, 1fr);
      row-gap: 4px;
      column-gap: 12px;

      .site {
        display: flex;
        gap: 6px;

        .marker {
          flex-shrink: 0;
          width: 14px;
          height: 20px;
          background-repeat: no-repeat;
          background-position: right center;
          background-size: contain;

          &.current-marker {
            background-image: url('./../../../assets/Marker-home.png');
          }

          &.target-marker {
            @for $i from 1 through 10 {
              &.marker-#{$i} {
                background-image: url('./../../../assets/Marker-#{$i}.png');
              }
            }
          }
        }

        .site-info {
          font-size: 10px;

          .site-name {
            color: #0f0f0f;
            font-weight: bold;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .site-address {
            color: #3c3c3b;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .site-container-collaborator {
      margin-left: 12px;
      height: 100%;

      .site {
        display: flex;
        margin: 0 0 8px;
        align-items: center;

        .marker {
          font-size: 10px;
          flex-shrink: 0;
          margin: 0 6px 0 0;
          width: 20px;
          height: 20px;
          border: solid 2px color.mix(colors.$warning-color, colors.$white-color, 65%);

          background: colors.$warning-color;
          color: colors.$white-color;
          border-radius: 20px;
          text-align: center;
          line-height: 20px;
          box-shadow:
            2px 4px 12px -2px rgba(0, 0, 0, 0.1),
            0 0 8px -4px rgba(colors.$warning-color, 0.2);

          &.small {
            margin: 2px 8px 2px 2px;
            width: 16px;
            height: 16px;
          }
        }

        .site-info {
          font-size: 10px;

          .site-name {
            color: #0f0f0f;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
